import * as React from "react";
const SvgFiRrShirtRunning = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20.975 10.778c-.062-.947-.548-1.819-1.326-2.306A3.48 3.48 0 0 1 18 5.5V1a1 1 0 1 0-2 0v3c0 2.206-1.794 4-4 4S8 6.206 8 4V1a1 1 0 1 0-2 0v4.5a3.48 3.48 0 0 1-1.65 2.972C3.518 8.993 3 9.951 3 10.974V19c0 2.757 2.243 5 5 5h8c2.757 0 5-2.243 5-5zM5 10.974c0-.339.157-.648.409-.806a5.5 5.5 0 0 0 2.035-2.274A5.99 5.99 0 0 0 12 10a5.98 5.98 0 0 0 4.556-2.106 5.5 5.5 0 0 0 2.034 2.274.85.85 0 0 1 .318.385L5.319 20.32c-.198-.4-.32-.844-.32-1.32zM16 22H8c-.436 0-.847-.098-1.221-.266L19 12.95v6.049A3.005 3.005 0 0 1 16 22"
    />
  </svg>
);
export default SvgFiRrShirtRunning;
